/* eslint-disable no-restricted-imports */
import { SingleGameFragment } from '~/client/components/Game/graphql/SingleGameFragment.generated';
import useCurrencyCode from '~/client/hooks/currency/useCurrencyCode';
import CurrencyDisplay from '~/client/shared/CurrencyDisplay';

import isValidMinMaxBet from '~/shared/utils/game/isValidMinMaxBet';
import MobileGameDetailsRow from '..';

type Props = Pick<SingleGameFragment, 'maxBet'>;

const MaxBetRow: FC<Props> = ({ maxBet }) => {
  const currencyCode = useCurrencyCode();

  if (!isValidMinMaxBet(currencyCode) || !maxBet) {
    return null;
  }

  return (
    <MobileGameDetailsRow translateId="casino.max_bet">
      <CurrencyDisplay amount={maxBet} isFormatted />
    </MobileGameDetailsRow>
  );
};

export default MaxBetRow;
